import { render, staticRenderFns } from "./TeamQuotasField.vue?vue&type=template&id=1223f1ac&scoped=true"
import script from "./TeamQuotasField.vue?vue&type=script&lang=js"
export * from "./TeamQuotasField.vue?vue&type=script&lang=js"
import style0 from "./TeamQuotasField.vue?vue&type=style&index=0&id=1223f1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1223f1ac",
  null
  
)

export default component.exports